// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__AzCBs","requiredAsterisk":"Info_requiredAsterisk__Vdlfa"};